import Axios from "axios";




const axiostool = Axios.create({
  baseURL: `${process.env.REACT_APP_API_URL!}/`,
  // baseURL: `http://127.0.0.1:8000/`,


  // http://127.0.0.1:8000
  // headers: { "Content-Type": "application/json" },
});

// JWT 토큰 인터셉터 추가 (더미 토큰 사용)
axiostool.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('token');
    
    // 토큰이 없으면 더미 토큰 생성
    if (!token) {
      token = 'dummy-jwt-token-for-register-system';
      localStorage.setItem('token', token);
    }
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 401 에러 처리를 위한 response 인터셉터 (간소화)
axiostool.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 401 에러가 발생해도 더미 토큰을 사용하므로 특별한 처리 없이 진행
    return Promise.reject(error);
  }
);

export default axiostool;